import { tabPath } from "../shell/navigation.js";
import { pathForSection, sectionFromHash } from "../common/sectionHash.js";

/**
 * The Finance page's sections and their deep links (#1681).
 *
 * React-free on purpose: `app/routing.ts` and `app/entityRoutes.ts` read this
 * to canonicalise and publish `/finance#transactions` without importing the
 * view. Order is the tab-strip order.
 */
export const FINANCE_SECTIONS = ["overview", "accounts", "transactions", "budgets", "recurring", "import"] as const;
export type FinanceSection = (typeof FINANCE_SECTIONS)[number];
export const FINANCE_DEFAULT_SECTION: FinanceSection = "overview";

export function financeSectionFromHash(hash: string): FinanceSection | null {
  return sectionFromHash(FINANCE_SECTIONS, hash);
}

/** `/finance` for Overview, `/finance#<section>` for the rest. */
export function financeSectionPath(section: FinanceSection): string {
  return pathForSection(tabPath("finance"), section, FINANCE_DEFAULT_SECTION);
}
